<template>
  <div class="login-container">
    <!-- Logo Above the Form -->
    <div class="maxxifiedLogoContainer">
      <img :src="tenantConfigs?.logo ? tenantConfigs?.logo : maxxifiedLogo" class="newLogo" alt="" />
    </div>
    <p class="loginTitleNew">Validate Email and set up password</p>
    <p class="loginSuitTitleNew">Please verify your email and create a password</p>

    <div class="login-card2">
      <form @submit.prevent="handleSubmit" class="login-card-inner-section">
        <div style="margin-top: 05px">
          <!-- {{ email }} -->
          <div class="password-input-wrapper">
            <custom-input :value="tempPassword" @update:value="tempPassword = $event" label="Enter Temporary Password" :type="showTempPassword ? 'text' : 'password'" required placeholder="Please enter your Temporary Password" :error="errors.tempPassword" />
            <button type="button" class="password-toggle-btn" @click="showTempPassword = !showTempPassword">
              <svg v-if="showTempPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
          </div>
        </div>
        <div style="margin-top: 30px">
          <div class="password-input-wrapper">
            <custom-input :value="newPassword" @update:value="newPassword = $event" label="New Password" :type="showNewPassword ? 'text' : 'password'" required placeholder="Enter new password" :error="errors.newPassword" />
            <button type="button" class="password-toggle-btn" @click="showNewPassword = !showNewPassword">
              <svg v-if="showNewPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
          </div>
        </div>
        <div style="margin-top: 30px">
          <div class="password-input-wrapper">
            <custom-input :value="confirmPassword" @update:value="confirmPassword = $event" label="Confirm Password" :type="showConfirmPassword ? 'text' : 'password'" required placeholder="Confirm new password" :error="errors.confirmPassword" />
            <button type="button" class="password-toggle-btn" @click="showConfirmPassword = !showConfirmPassword">
              <svg v-if="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
          </div>
        </div>

        <div class="buttonDiv">
          <custom-button type="submit" :disabled="loading">
            {{ loading ? 'Verifying...' : 'Verify' }}
            <div v-if="loading" class="spinner-border text-white spinner-grow-sm" role="status"></div>
          </custom-button>
        </div>
      </form>
    </div>

    <p class="goBackLabel" @click="goBack">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke="#32393E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      Back To Login
    </p>
    <Footer />
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import CustomInput from '../../components/CustomInput.vue'
import CustomButton from '../../components/CustomButton.vue'
import { post, get } from '@/utils/api'
import { showToast } from '@/utils/toast'
import maxxifiedLogo from '@/assets/maxxified_logo.png'
import Footer from '../../components/Footer.vue'
export default {
  data() {
    return {
      maxxifiedLogo,
      email: '',
      tempPassword: '',
      newPassword: '',
      confirmPassword: '',
      showTempPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      loading: false,
      tenantConfigs: {},
      errors: {
        tempPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
    }
  },
  created() {
    this.email = this.$route.query.email?.replace(/\s/g, '+')
    localStorage.setItem('email', this.email)
    if (!this.email) {
      showToast({
        title: 'Invalid URL',
        message: 'The registration URL is invalid or missing email parameter',
        type: 'error',
      })
    } else {
      this.getTenantConfig()
    }
  },
  mounted() {
    document.title = 'Register'
    const encodedEmail = encodeURIComponent(this.email)
    if (encodedEmail) this.handleOnBasisOfUserStatus(encodedEmail)
  },
  components: {
    CustomInput,
    CustomButton,
    Footer,
  },
  computed: {
    auth() {
      return useAuthStore()
    },
  },
  methods: {
    async getTenantConfig() {
      try {
        const encodedEmail = encodeURIComponent(this.email)
        const response = await get(`public/tenant-config?key=email&value=${encodedEmail}`)

        if (response?.status !== 200 || !response.data?.data) {
          return
        }

        const config = response.data.data
        this.tenantConfigs = config

        const { selected_theme, theme_primary_color, theme_secondary_color, custom_primary_color, custom_secondary_color } = config

        const primary = selected_theme === 'Custom' ? custom_primary_color : theme_primary_color
        const secondary = selected_theme === 'Custom' ? custom_secondary_color : theme_secondary_color

        if (primary) localStorage.setItem('theme_primary_color', primary)
        if (secondary) localStorage.setItem('theme_secondary_color', secondary)
      } catch (error) {
      }
    },

    async handleOnBasisOfUserStatus(emailId) {
      try {
        const response = await get(`public/user-info?email=${emailId}`)

        if (response?.data && !response.data.error) {
          const user = response.data.data
          if (user.status === 'Active') {
            showToast({
              title: 'Error',
              message: `This user is already registered. Proceed to login.`,
              type: 'error',
            })

            this.$router.push('/login')
          }
        } else {
          showToast({
            title: 'Error',
            message: 'Failed to fetch user status.',
            type: 'error',
          })
        }
      } catch (error) {
        showToast({
          title: 'Error',
          message: 'An error occurred while fetching user status.',
          type: 'error',
        })
      } finally {
        // optional cleanup or modal close
        // this.closeConfirmModal()
      }
    },
    goBack() {
      this.$router.push('/login')
    },
    async handleSubmit() {
      if (this.loading) return

      // Clear all errors
      this.errors = {
        tempPassword: '',
        newPassword: '',
        confirmPassword: '',
      }

      // Validate fields
      if (!this.tempPassword?.trim()) {
        this.errors.tempPassword = 'Temporary password is required'
        return
      }

      if (!this.newPassword?.trim()) {
        this.errors.newPassword = 'New password is required'
        return
      }

      if (!this.confirmPassword?.trim()) {
        this.errors.confirmPassword = 'Please confirm your password'
        return
      }

      if (this.newPassword !== this.confirmPassword) {
        this.errors.confirmPassword = 'Passwords do not match'
        return
      }

      try {
        this.loading = true
        const response = await post('/auth/reset-temp-password', {
          email: this.email,
          tempPassword: this.tempPassword.trim(),
          newPassword: this.newPassword.trim(),
        })

        if (response?.data?.code === 200) {
          showToast({
            title: 'Success',
            message: 'Password updated successfully',
            type: 'success',
          })
          const session = response?.data?.data?.Session
          localStorage.setItem('session', session)
          const authResult = response.data.data.AuthenticationResult
          localStorage.setItem('AccessToken', authResult?.AccessToken)
          localStorage.setItem('IdToken', authResult?.IdToken)
          localStorage.setItem('RefreshToken', authResult?.RefreshToken)
          this.auth.AccessToken = authResult?.AccessToken
          this.auth.IdToken = authResult?.IdToken
          this.auth.RefreshToken = authResult?.RefreshToken

          this.$router.push('/otp-verification')
        } else {
          showToast({
            title: 'Error',
            message: response?.data?.message || 'Failed to update password',
            type: 'error',
          })
        }
      } catch (error) {
        // Check if error is related to temporary password
        if (error?.response?.data?.message?.toLowerCase().includes('temporary password')) {
          this.errors.tempPassword = 'Invalid temporary password'
        } else {
          showToast({
            title: 'Error',
            message: error?.response?.data?.message || 'Failed to update password',
            type: 'error',
          })
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
@import '@/styles/login.css';

.password-input-wrapper {
  position: relative;
  width: 100%;
}

.password-input-wrapper :deep(.input-wrapper input) {
  padding-right: 45px;
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  top: calc(19.58px + 10px + 5px + 23px);
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  z-index: 10;
  transition: color 0.2s;
  height: 20px;
  width: 20px;
  margin-top: 0;
}

.password-toggle-btn:hover {
  color: var(--primary-color, #164863);
}

.password-toggle-btn:focus {
  outline: none;
}

.password-toggle-btn svg {
  width: 20px;
  height: 20px;
  stroke-width: 2;
}
</style>
